export default [
    {
        code: 'NAME',
        name: 'Property Name',
    },
    {
        code: 'ADDRESS',
        name: 'Address',
    },
    {
        code: 'CITY',
        name: 'City',
    },
    {
        code: 'STATE',
        name: 'State',
    },
    {
        code: 'ZIP',
        name: 'Zip',
    },
    {
        code: 'MARKET',
        name: 'Market',
    },
    {
        code: 'STATUS',
        name: 'Status',
    },
    {
        code: 'HSC_STATUS',
        name: 'AthCap Status',
    },
    {
        code: 'SOURCE',
        name: 'Source',
    },
    {
        code: 'TRANSACTION_TYPE',
        name: 'Transaction Type',
    },
    {
        code: 'CATEGORY',
        name: 'Category',
    },
    {
        code: 'TYPE',
        name: 'Type',
    },
    {
        code: 'SINGLE_TENANT_SUBCATEGORY',
        name: 'STNL Tenant subcategory',
    },
    {
        code: 'LEASE_TYPE',
        name: 'Lease Type',
    },
    {
        code: 'MULTI_TENANT_SUBCATEGORY',
        name: 'MT Tenant subcategory',
    },
    {
        code: 'TENANT_ID',
        name: 'Tenant',
    },
    {
        code: 'SQFT',
        name: 'Square Feet',
    },
    {
        code: 'YEAR_BUILT',
        name: 'Year Built',
    },
    {
        code: 'LIST_PRICE',
        name: 'List Price',
    },
    {
        code: 'CAPITALIZATION_RATE',
        name: 'List Cap Rate',
    },
    {
        code: 'PRICE_PER_SQFT',
        name: 'Price per Square Foot',
    },
    {
        code: 'SOLD_PRICE',
        name: 'Price at Close',
    },
    {
        code: 'CLOSE_CAP_RATE',
        name: 'Cap Rate at Close',
    },
    {
        code: 'CLOSE_PRICE_PER_SQFT',
        name: 'Price per Square Foot at Close',
    },
    {
        code: 'NET_OPERATING_INCOME',
        name: 'Net Operating Income',
    },
    {
        code: 'VACANCY',
        name: 'Occupancy',
    },
    {
        code: 'LEASE_EXPIRATION_DATE',
        name: 'Remaining Term',
    },
    {
        code: 'CLOSE_OF_ESCROW',
        name: 'Close of Escrow',
    },
    {
        code: 'LISTED_DATE',
        name: 'Date Listed',
    },
    {
        code: 'SELLER_COMPANY_STATE',
        name: 'Seller State',
    },
    {
        code: 'STRIVE_AGENT_TEAM',
        name: 'STRIVE Team Member',
    },
    {
        code: 'LISTING_AGENT_4',
        name: 'Listing Agent',
    },
    {
        code: 'LISTING_AGENT_4_FIRM',
        name: 'Listing Agent Company',
    },
    {
        code: 'BUYER_COMPANY_STATE',
        name: 'Buyer State',
    },
    {
        code: 'BUYER_AGENT_4',
        name: 'Buying Agent',
    },
    {
        code: 'BUYER_AGENT_4_FIRM',
        name: 'Buying Agent Company',
    },
    {
        code: 'MEDIA_KIT',
        name: 'OM',
    }
];